var map = {
	"./circle_black.svg": 53547,
	"./circle_blue.svg": 74122,
	"./ellipse_black.svg": 83275,
	"./france.svg": 14098,
	"./highlighted_yellow.svg": 58049,
	"./icone/carousel_new.svg": 77297,
	"./icons/Cart.svg": 84908,
	"./icons/Cart_add.svg": 18480,
	"./icons/Cart_delete.svg": 77226,
	"./icons/Cart_remove.svg": 69715,
	"./icons/_info.svg": 66853,
	"./icons/add_icon.svg": 75937,
	"./icons/add_prod.svg": 4038,
	"./icons/add_prodOLD.svg": 16188,
	"./icons/ask.svg": 74769,
	"./icons/carousel.svg": 96928,
	"./icons/carrello.svg": 17790,
	"./icons/categorie.svg": 17475,
	"./icons/clear_chart.svg": 24568,
	"./icons/close.svg": 75126,
	"./icons/close_.svg": 15981,
	"./icons/condividi.svg": 66185,
	"./icons/email.svg": 30582,
	"./icons/facebook.svg": 52542,
	"./icons/hatchef.svg": 67557,
	"./icons/icon-carousel.svg": 84804,
	"./icons/icone/_info.svg": 93724,
	"./icons/icone/book-open-solid.svg": 68209,
	"./icons/icone/columns-solid.svg": 86148,
	"./icons/icone/file-pdf-solid.svg": 96068,
	"./icons/icone/hatchef.svg": 82468,
	"./icons/icone/info.svg": 30697,
	"./icons/icone/list-solid.svg": 12635,
	"./icons/icone/magnifying-glass-solid.svg": 6555,
	"./icons/icone/play.svg": 51303,
	"./icons/icone/plus.svg": 8961,
	"./icons/icone/share-square-solid-prod.svg": 87462,
	"./icons/icone/share-square-solid.svg": 42428,
	"./icons/icone/specs.svg": 67227,
	"./icons/icone/world.svg": 14583,
	"./icons/index-icon-bookmark.svg": 93553,
	"./icons/index-icon.svg": 50376,
	"./icons/info.svg": 94858,
	"./icons/informazioni.svg": 20051,
	"./icons/internal_link.svg": 94212,
	"./icons/mappa.svg": 77097,
	"./icons/markers-SVG/ask.svg": 55732,
	"./icons/markers-SVG/info.svg": 75645,
	"./icons/markers-SVG/list.svg": 44401,
	"./icons/markers-SVG/recipe.svg": 80143,
	"./icons/markers-SVG/web.svg": 30001,
	"./icons/pagine.svg": 39048,
	"./icons/pdf.svg": 99508,
	"./icons/play.svg": 7840,
	"./icons/play_ip.svg": 7252,
	"./icons/plus.svg": 68718,
	"./icons/plus_ip.svg": 26618,
	"./icons/prodotti.svg": 19533,
	"./icons/promo.svg": 76927,
	"./icons/promo2.svg": 54287,
	"./icons/promo3.svg": 17886,
	"./icons/promo_10.svg": 26869,
	"./icons/promo_classic.svg": 40686,
	"./icons/remove_prod.svg": 70562,
	"./icons/remove_prodOLD.svg": 60337,
	"./icons/remove_prod_.svg": 96921,
	"./icons/ricetta.svg": 27914,
	"./icons/schermo_intero.svg": 42805,
	"./icons/shop_list.svg": 87917,
	"./icons/specs.svg": 24682,
	"./icons/telephone.svg": 61650,
	"./icons/video.svg": 9447,
	"./icons/volantino.svg": 18372,
	"./icons/whatsapp.svg": 12700,
	"./icons/world.svg": 42942,
	"./logo_catalog_interattivo.svg": 97326,
	"./logo_interattivo-old.svg": 61194,
	"./logo_interattivo.svg": 43534,
	"./logo_interattivo_free.svg": 19855,
	"./logo_interattivo_new.svg": 52069,
	"./logo_menu_interattivo.svg": 2500,
	"./logo_volantinointerattivo_free.svg": 84671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;